import clsx from "clsx";
import { FC } from "react";
import { Link } from "react-router-dom";
import { assetLabel, Icons, useLocale, useTranslation } from "rujira.ui";
import { assetToTradeUrlSegment } from "../../services/assetUrl";
import { siteOrigin } from "../../services/siteOrigin";
import { RangePositionShareButton } from "../../sharing/RangePositionCard";
import { cclCopyParams } from "../../trade/tradeUrlState";
import { Row } from "../leaderboard/types";

export const RangeActions: FC<{ row: Row; compact?: boolean }> = ({
  row,
  compact,
}) => {
  const { t } = useTranslation("common");
  const { toRoot } = useLocale();
  const { node } = row;
  const { assetBase, assetQuote } = node.pair;
  const a = node.analytics;

  const copyTo = toRoot(
    `/trade/${assetToTradeUrlSegment(assetBase)}/${assetToTradeUrlSegment(
      assetQuote
    )}${cclCopyParams({
      low: BigInt(node.low),
      high: BigInt(node.high),
      spread: BigInt(node.spread),
      fee: BigInt(node.fee),
    })}`
  );

  return (
    <div className={clsx("flex ai-c", compact ? "gap-0" : "gap-1")}>
      <RangePositionShareButton
        copyUrl={siteOrigin() + copyTo}
        baseLabel={assetLabel(assetBase)}
        quoteLabel={assetLabel(assetQuote)}
        low={node.low}
        high={node.high}
        current={node.price}
        spread={node.spread}
        fee={node.fee}
        apr={a?.apr}
        ageDays={a && row.ageValid ? row.nums.age : null}
        shareMsg={t("shareMsgOtherPosition", {
          base: assetLabel(assetBase),
          quote: assetLabel(assetQuote),
        })}
      />
      {compact ? (
        <Link
          to={copyTo}
          aria-label="Copy"
          className="block transparent w-3 h-3 color-grey hover-white">
          <Icons.Copy className="block w-3 h-3" />
        </Link>
      ) : (
        <Link
          to={copyTo}
          className="button button--xs button--outline button--blue w-full button--icon-right nowrap">
          Copy
          <Icons.AngleRight />
        </Link>
      )}
    </div>
  );
};
